<template>
  <div class="course-component" @click="toDetails(obj.classId, obj.verifyStatus, obj.type)">
    <img v-if="obj.coverUrl" :src="obj.coverUrl" class="course-img" alt="">
    <div v-else class="empty-course-img">
      <img :src="empty_img" alt="">
    </div>
    <p class="course-title">{{ obj.className }}</p>
    <p class="study-detail">
      <span :class="getCourseClass" class="type">{{ getCourseType }}</span>
      <span v-if="obj.type!=2" class="stock">{{ obj.studyCount }}人学习</span>
    </p>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: 'courseComponent',
  filters: {
    filterClass(name) {
      return name;
    }
  },
  components: {
    [Toast.name]: Toast
  },
  props: {
    obj: {
      type: Object,
      default: () => ({})
    },
    studentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      empty_img: require('@/assets/img/course/empty_course.png')
    };
  },
  computed: {
    getCourseType() {
      let type = Number(this.obj.type);
      let returnType;
      switch (type) {
        case 1:
          returnType = '直播课';
          break;
        case 2:
          returnType = '录播课';
          break;
        case 3:
          returnType = '面授课';
          break;
        case 4:
          returnType = '实物商品';
          break;
        case 5:
          returnType = '虚拟商品';
          break;
        default:
          returnType = '';
          break;
      }
      return returnType;
    },
    getCourseClass() {
      let type = Number(this.obj.type);
      let returnClassName;
      switch (type) {
        case 1:
          returnClassName = 'blue';
          break;
        case 2:
          returnClassName = 'orange';
          break;
        case 3:
          returnClassName = 'green';
          break;
        case 4:
          returnClassName = 'blue';
          break;
        case 5:
          returnClassName = 'blue';
          break;
        default:
          returnClassName = '';
          break;
      }
      return returnClassName;
    }
  },
  methods: {
    toDetails(classId, verifyStatus, type) {
      if (~~verifyStatus === 0 || ~~verifyStatus === 1 || ~~verifyStatus === 3) {
        Toast('老师正在筹备内容，敬请期待');
      } else {
        if (~~this.obj.type === 1 || ~~this.obj.type === 3 || ~~this.obj.type === 2) {
          this.$router.push({ name: 'StudyDetails', query: { classId, studentId: this.studentId, courseTypes: type }});
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course-component {
  .type {
    font-size: 26px;
    line-height: 36px;
    padding: 4px 16px;
    border-radius: 20px;
  }

  .empty-course-img {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #E9E9E9;
    border-radius: 10px 10px 0px 0px;
    img {
      width: 60px;
      height: 52px;
    }
  }

  .course-img,
  .empty-course-img {
    width: 100%;
    height: 183px;
  }

  .blue {
    color: $blue;
    background: rgba($blue, 0.1);
  }

  .orange {
    color: #ff9d06;
    background: rgba(#ff9d06, 0.1);
  }

  .green {
    color: #62bb00;
    background: rgba(#62bb00, 0.15);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/study/course.vue